import { styled } from 'goober';
import { Container, ImageForSlides } from './slideOne';

const WhatItIsText = styled('div')`
  padding-top: 24px;
  font-size: 25px;
  font-weight: 500;
  line-height: 38px;
  font-style: normal;
  color: #949494;
  margin-top: 0;
  @media only screen and (max-width: 600px) {
    width: 95%;
    font-size: 18px;
    line-height: 24px;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 16px;
  }
`;
const TitleText = styled('div')`
  width: 353px;
  margin-bottom: 20px;
  font-style: normal;
  font-size: 30px;
  font-weight: 600;
  line-height: 35px;
  margin-top: 20px;
  color: #00733b;
  @media only screen and (max-width: 600px) {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 254px;
    font-size: 18px;
    line-height: 22px;
  }
`;
export const StepsTextContainer = styled('div')`
  width: 80%;
  height: fit-content;
  display: flex;
  align-items: center;
  background: #ecfff1;
  margin-bottom: 20px;
  border-radius: 8px;
  margin-top: 0;
  @media only screen and (max-width: 600px) {
    margin-bottom: 12px;
    width: 200px;
  }
`;
export const PointsContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 39px;
  height: 39px;
  background: #ecfff1;
  border-radius: 50%;
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.2);
  margin-right: 17px;
  margin-left: -8px;
  @media only screen and (max-width: 600px) {
    width: 25px;
    height: 25px;
  }
`;
export const Points = styled('span')`
  width: 6px;
  height: 22px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #3a8950;
  @media only screen and (max-width: 600px) {
    font-size: 15px;
  }
`;
const StepsText = styled('p')`
  height: fit-content;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #04581b;
  width: ${(props) => (props.stepsCount === 2 ? '55%' : '100%')};
  @media only screen and (max-width: 600px) {
    font-size: 12px;
    line-height: 14px;
    width: ${(props) => (props.stepsCount === 2 ? '62%' : '153px')};
  }
`;
const ImageContainerForSlides = styled('div')`
  margin-top: 4px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 248px;
  height: 270px;
  @media only screen and (min-height: 360px) and (max-width: 600px) {
    width: 43%;
    height: 33vw;
  }
  @media only screen and (min-height: 320px) and (max-width: 359px) {
    width: 35%;
    height: 25vw;
  }
`;
const SlideTwo = () => {
  return (
    <Container>
      <WhatItIsText> How does it work?</WhatItIsText>
      <TitleText>Avail instant credit with no paperwork</TitleText>
      <StepsTextContainer>
        <PointsContainer>
          <Points>1</Points>{' '}
        </PointsContainer>
        <StepsText stepsCount={1}>
          4.5+ crore users are pre-approved from Trusted Banks/NBFCs.
        </StepsText>
      </StepsTextContainer>

      <StepsTextContainer>
        <PointsContainer>
          <Points>2</Points>{' '}
        </PointsContainer>
        <StepsText stepsCount={2}>
          A pre-approved user can start shopping instantly. No KYC required.
          Just check eligibility with mobile number.
        </StepsText>
      </StepsTextContainer>

      <ImageContainerForSlides>
        <ImageForSlides
          style={{
            backgroundImage:
              "url('https://iccdn.in/img/edu_modal_hero_image2.png')",
          }}
        />
      </ImageContainerForSlides>
    </Container>
  );
};

export default SlideTwo;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/educationalModal/slideTwo.js